import { createSelector } from '@reduxjs/toolkit';
import { makeTranslator } from 'translation/core';

const getLang = (state) => state.user.lang;
const getTranslations = (state) => state.user.translation;

export const selectTranslation = createSelector(
  [getTranslations, getLang],
  (translation, lang) => makeTranslator(translation, lang)
);
